import * as yup from "yup"
import { Formato, RelazioneAtlante } from "../../types"

export function initialValuesRelazione(relazione?: RelazioneAtlante | undefined) {
  if (relazione) {
    return relazione
  }
  return {
    nome: "",
  }
}

export function validationSchemaRelazione() {
  return yup.object().shape({
    nome: yup.string().required("Campo obbligatorio"),
  })
}
